import { selectContractorByUuid } from '../../payroll.selectors'
import { getContractorWages } from '../../helpers'
import { ContractorPayrollHeader } from './ContractorPayrollHeader'
import { ContractorPayrollOverview } from './ContractorPayrollOverview'
import { ContractorPaymentTable } from './ContractorPaymentTable'
import { PayrollError } from '../../PayrollError'
import { POST_CONTACTOR_PAYMENT_KEY } from '../../payrollActions'
import { Button, Icon, Text } from '@/ui'
import { useReselector } from '@/utils/sharedHooks'
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons'
import { TypographyStyles } from '@/styles'

export const ContPayrollReviewTab = ({
  contractorUuid,
  hours,
  bonus,
  reimbursement,
  wage,
  payDate,
  goForward,
  goBack,
}: {
  contractorUuid: string
  hours: string
  bonus: string
  wage: string
  reimbursement: string
  payDate: string
  goForward: () => void
  goBack: () => void
}) => {
  const contractor = useReselector(selectContractorByUuid, contractorUuid)

  if (!contractor) {
    return null
  }

  const { wages, total } = getContractorWages({
    contractor,
    bonus,
    hours,
    wage,
    reimbursement,
  })

  return (
    <div className="flex flex-col gap-6">
      <ContractorPayrollHeader currentTab={2} />
      <Text variant={TypographyStyles.BODY_LG}>Review and submit</Text>
      <Text variant={TypographyStyles.BODY_MD}>
        Please review the payments you’re submitting — we’ll debit funds on the
        date listed below.
      </Text>

      <PayrollError fetchKey={POST_CONTACTOR_PAYMENT_KEY} />
      <ContractorPayrollOverview payDate={payDate} total={total} />

      <Text variant={TypographyStyles.BODY_MD}>
        <b>Note:</b> Due to banking regulations, we are unable to recover funds
        on your behalf once the money has reached your contractor’s account. If
        an error or overpayment was made, you will need to coordinate directly
        with your contractor.
      </Text>

      <Text variant={TypographyStyles.H1}>What your company pays</Text>

      <div>
        <ContractorPaymentTable
          contractor={contractor}
          hours={hours}
          bonus={bonus}
          wages={wages}
          reimbursement={reimbursement}
          total={total}
        />
      </div>

      <div className="flex flex-col md:flex-row justify-between items-center md:items-end gap-4 mt-4">
        <div className="w-full md:w-1/4">
          <Button variant="secondary" onClick={goBack} className="w-full">
            Go Back
          </Button>
        </div>
        <div className="hidden md:block md:w-1/2" />
        <div className="w-full md:w-1/4">
          <Button onClick={goForward} className="w-full">
            Submit Payment <Icon icon={faArrowRight} />
          </Button>
        </div>
      </div>
    </div>
  )
}
